import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "list"];

  addDomain(event) {
    event.preventDefault();

    const rawValue = (this.inputTarget.value || "").trim();
    if (!rawValue) return;

    rawValue
      .split(",")
      .map((domain) => domain.trim())
      .filter(Boolean)
      .forEach((domain) => this.appendChip(domain));

    this.inputTarget.value = "";
  }

  removeDomain(event) {
    const removeButton = event.target.closest("[data-remove-domain]");
    if (!removeButton) return;

    event.preventDefault();
    removeButton.closest("[data-domain-chip]")?.remove();
  }

  appendChip(domain) {
    const existingDomains = Array.from(
      this.listTarget.querySelectorAll('input[name="organization[domains][]"]')
    ).map((input) => input.value);
    if (existingDomains.includes(domain)) return;

    const wrapper = document.createElement("div");
    wrapper.className = "btn-group btn-group-sm";
    wrapper.setAttribute("role", "group");
    wrapper.dataset.domainChip = "true";

    const label = document.createElement("button");
    label.type = "button";
    label.className = "btn btn-secondary";
    label.disabled = true;
    label.textContent = domain;

    const remove = document.createElement("button");
    remove.type = "button";
    remove.className = "btn btn-outline-secondary";
    remove.setAttribute("data-remove-domain", "true");
    remove.setAttribute("aria-label", "Remove domain");
    remove.textContent = "x";

    const hidden = document.createElement("input");
    hidden.type = "hidden";
    hidden.name = "organization[domains][]";
    hidden.value = domain;

    wrapper.appendChild(label);
    wrapper.appendChild(remove);
    wrapper.appendChild(hidden);
    this.listTarget.appendChild(wrapper);
  }
}
